import type { FaireProductEntity } from "../../entity_types/product";

export const toysmith_6: FaireProductEntity = {
  token: "toysmith-6",
  type: "product",
  name: "Get Outside GO!™ Play Triple Play Combo Set",
  brandName: "Toysmith",
  imageUrl:
    "https://cdn.faire.com/fastly/9b9f734c74062aa5ded4fed7cdc19648e1dd690c4794bc09860520c03bbc2e63.jpeg?bg-color=FFFFFF&dpr=1&fit=crop&format=jpg&height=720&precrop=1634,1633,x82,y0,safe&width=720",
  priceDollars: 18,
  msrpDollars: 36,
  freeShipping: false,
  isBestseller: false,
  description: "",
  categoryTokens: ["cat_kids-toys"],
  tags: [],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-products-migration",
  },
};
